<template>
  <vs-popup
    title="Filter la liste des demandes"
    :active.sync="isPromptActiveLocal"
  >
    <vs-row>
      <vs-col vs-type="flex" vs-w="6">
        <vs-select
          autocomplete
          class="w-full"
          label="Client"
          placeholder="Selectionner un client"
          v-model="form.client"
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.social_reason"
            v-for="(item, index) in customers"
          />
        </vs-select>
      </vs-col>
      <vs-col vs-type="flex" vs-w="6">
        <vs-select
          autocomplete
          class="w-full"
          label="Canal"
          v-model="form.canal"
          placeholder="Selectionner un canal"
        >
          <vs-select-item
            :key="index"
            :value="item"
            :text="item"
            v-for="(item, index) in canal"
          />
        </vs-select>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-type="flex" vs-w="6">
        <vs-select
          autocomplete
          class="w-full"
          label="Priorité"
          v-model="form.priority"
          placeholder="Selectionner la priorité"
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.name"
            v-for="(item, index) in priorities"
          />
        </vs-select>
      </vs-col>
      <vs-col vs-type="flex" vs-w="6">
        <vs-select
          autocomplete
          class="w-full"
          label="Type de demande"
          v-model="form.type"
          placeholder="Selectionner un type"
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.name"
            v-for="(item, index) in categories"
          />
        </vs-select>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-type="flex" vs-w="6">
        <vs-input
          label="Date début"
          type="date"
          class="w-full"
          v-model="form.dateDebut"
        />
      </vs-col>
      <vs-col vs-type="flex" vs-w="6">
        <vs-input
          label="Date fin"
          type="date"
          class="w-full"
          v-model="form.dateFin"
        />
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-type="flex" vs-w="6">
        <vs-input
          label="Numéro ticket"
          type="text"
          class="w-full"
          v-model="form.ref"
        />
      </vs-col>
      <vs-col vs-type="flex" vs-w="6">
        <vs-input
          label="Numéro de téléphone"
          type="number"
          class="w-full"
          v-model="form.phone"
        />
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-type="flex" vs-w="6">
        <vs-input
          label="Code contrat"
          type="number"
          class="w-full"
          v-model="form.code_contract"
        />
      </vs-col>
      <vs-col vs-type="flex" vs-w="6">
        <vs-input
          label="Objet"
          type="text"
          class="w-full"
          v-model="form.title"
        />
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-button
        color="primary"
        class="mt-2 mr-2"
        type="filled"
        @click="searchMethod()"
        >Filtrer</vs-button
      >
      <vs-button
        color="primary"
        class="mt-2"
        type="border"
        @click="$emit('closePrompt')"
        >Annuler</vs-button
      >
    </vs-row>
  </vs-popup>
</template>

<script>
import { _buildQuery } from "../../helpers/helper";
const search_temp = {
  page: 1,
  client: "",
  canal: "",
  priority: "",
  type: "",
  dateDebut: "",
  dateFin: "",
  ref: "",
  phone: "",
  code_contract: "",
  title: "",
};
export default {
  name: "FilterList",
  props: {
    isPromptActive: {
      type: Boolean,
      required: true,
    },
    customers: {
      type: Array,
      required: true,
    },
    priorities: {
      type: Array,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    callBackFilter: {
      type: Function,
    },
  },
  data: () => ({
    form: {
      page: 1,
      client: "",
      canal: "",
      priority: "",
      type: "",
      dateDebut: "",
      dateFin: "",
      ref: "",
      phone: "",
      code_contract: "",
      title: "",
    },
    canal: ["CCMT", "MAIL"],
  }),
  watch: {
    isPromptActive(val) {
      if (!val) return;
    },
  },
  computed: {
    isPromptActiveLocal: {
      get() {
        return this.isPromptActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closePrompt");
        }
      },
    },
  },
  methods: {
    searchMethod() {
      this.$vs.loading();
      this.$http
        .get("/requests" + _buildQuery(this.form))
        .then((response) => {
          this.$vs.loading.close();
          let stringSearch = { ...this.form };
          delete stringSearch.page;
          this.callBackFilter(response, stringSearch);
          this.$emit("closePrompt");
          this.form = { ...search_temp };
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
</style>
